'use client';

/**
 * TanStack Query hooks for Meridian chat API
 * 
 * These hooks provide a consolidated, type-safe interface for all chat and message operations
 * with automatic caching, pagination, and cache invalidation.
 */

export { useChatsQuery } from './useChatsQuery.js';
export type { UseChatsQueryOptions, UseChatsQueryResult } from './useChatsQuery.js';

export { useMessagesQuery } from './useMessagesQuery.js';
export type { UseMessagesQueryOptions, UseMessagesQueryResult } from './useMessagesQuery.js';

/**
 * Simplified hooks without TanStack Query overhead
 * Use these for simpler use cases where caching and pagination aren't needed
 */
export { useSimpleChatsQuery } from './useSimpleChatsQuery.js';
export type { UseSimpleChatsQueryOptions, UseSimpleChatsQueryResult } from './useSimpleChatsQuery.js';

export { useSimpleMessagesQuery } from './useSimpleMessagesQuery.js';
export type { UseSimpleMessagesQueryOptions, UseSimpleMessagesQueryResult } from './useSimpleMessagesQuery.js';

export {
  useSendMessageMutation,
  useDeleteChatMutation,
  useUpdateChatMutation,
  useDeleteMessageMutation,
  useEditMessageMutation,
  useCreateChatMutation,
} from './useChatMutations.js';
export type {
  UseSendMessageMutationOptions,
  UseDeleteChatMutationOptions,
  UseUpdateChatMutationOptions,
  UseDeleteMessageMutationOptions,
  UseEditMessageMutationOptions,
  UseCreateChatMutationOptions,
} from './useChatMutations.js';
